module.exports = __webpack_public_path__ + "media/src/images/topic_on-ca4b4cf5c3d81ae2486653779a33db3d.png";